export default {
    updateToCurrent: {
        action: 'Activate all new trends (publication year 2024)',
        confirmation: {
            title: 'Confirm activation',
            content: 'Do you want to activate all new trends and thus unlock them for your account?',
            confirm: 'Activate Trends'
        }
    },
    deactivateAll: {
        action: 'Deactivate all trends',
        confirmation: {
            title: 'Note',
            content: 'Do you really want to deactivate all trends? This will remove all Trendone Macro and Mega Trends from your account. Re-activation of trends with a release date before 2022 can only be done individually.',
            confirm: 'Deactivate all trends'
        }
    },
    enableAutomaticUpdate: {
        action: 'Automatic trend update',
        confirmation: {
            title: 'Automatic Trend universe Update',
            content: 'I would like to always automatically apply all updates to the trend universe.<br />You can reverse this decision at any time.',
            confirm: 'Submit'
        }
    }
}
